import React from 'react';
import { Link } from 'react-router-dom';

const options = [
  { icon: '🛵', name: 'Delivery', desc: '30–45 min to Seguku & surrounds', cta: 'Order Now', link: '/menu' },
  { icon: '🥡', name: 'Takeaway', desc: 'Skip the wait — order ahead for pickup', cta: 'Order Ahead', link: '/menu' },
  { icon: '🍽', name: 'Dine In', desc: 'Enjoy our warm, family-friendly ambiance', cta: 'Reserve Table', link: '/booking' },
  { icon: '🎁', name: 'Catering', desc: 'Let us bring the feast to your event', cta: 'Enquire', link: '/contact' },
];

const DeliveryOptions = () => (
  <section className="section-padding" style={{ backgroundColor: '#faf8f5' }}>
    <div className="container">
      <div className="text-center mb-5 reveal">
        <span className="section-subtitle">How You Want It</span>
        <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600 }}>
          Delivery & Dining Options
        </h2>
        <div className="gold-divider-center"></div>
      </div>
      <div className="row g-4">
        {options.map((opt, i) => (
          <div key={i} className="col-md-6 col-lg-3 reveal" style={{ transitionDelay: `${i * 0.1}s` }}>
            <div className="delivery-tile">
              <div className="delivery-icon">{opt.icon}</div>
              <h5 style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600, fontSize: '1.2rem', marginBottom: '8px' }}>{opt.name}</h5>
              <p style={{ color: '#888', fontSize: '0.88rem', lineHeight: 1.7, marginBottom: '16px' }}>{opt.desc}</p>
              <Link to={opt.link} className="btn btn-sm" style={{
                backgroundColor: '#D4AF37', color: '#fff', padding: '8px 20px',
                fontSize: '0.75rem', borderRadius: '8px', letterSpacing: '1px'
              }}>{opt.cta}</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default DeliveryOptions;
